import { render, staticRenderFns } from "./Bayar.vue?vue&type=template&id=18ceda7b&scoped=true&"
import script from "./Bayar.vue?vue&type=script&lang=js&"
export * from "./Bayar.vue?vue&type=script&lang=js&"
import style0 from "./Bayar.vue?vue&type=style&index=0&id=18ceda7b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ceda7b",
  null
  
)

export default component.exports